import { SessionSummary } from '@bioliberty/lifemind';
import { Info, Wand2 } from 'lucide-react';
import posthog from 'posthog-js';
import { useGenerateSessionNoteMutation } from '../../../api';
import { Button } from '../../../components/Button';
import { useToaster } from '../../../hooks/useToaster';
import { Event } from '../../../lib/posthog';

interface MissingSessionNoteContentProps {
  session: SessionSummary;
}

export function MissingSessionNoteContent({ session }: MissingSessionNoteContentProps) {
  const toast = useToaster();
  const [generate, { isLoading }] = useGenerateSessionNoteMutation();

  const onClick = async () => {
    if (isLoading) {
      return;
    }

    posthog.capture(Event.SessionNoteRequestButtonClick, { sessionId: session.sessionId });

    try {
      await generate({ patientId: session.patientId, sessionId: session.sessionId }).unwrap();
    } catch {
      toast.error('Failed to request the AI summary. Please try again later.');
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 py-4">
      <div className="flex items-center gap-2">
        <Info className="h-4 w-4" />
        <div>Your summary is pending. Please check back soon.</div>
      </div>
      <Button size="m" icon={Wand2} isLoading={isLoading} onClick={onClick}>
        Request Summary
      </Button>
    </div>
  );
}
